import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Minivision Content Top
 */
const minivisionContentTop = buildAsyncStatReducer({
    key: Metrics.MINIVISION_CONTENT_TOP,
    types: {
        request: Types.DASHBOARD_MINIVISION_CONTENT_TOP.request,
        success: Types.DASHBOARD_MINIVISION_CONTENT_TOP.success,
        failure: Types.DASHBOARD_MINIVISION_CONTENT_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { content, count } = payload[0] || {}
        return { content, count }
    },
})

/**
 * Minivision Dwell Timeline reducer
 */
const minivisionDwellTimeline = buildAsyncStatReducer({
    key: Metrics.MINIVISION_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_MINIVISION_DWELLTIMELINE.request,
        success: Types.DASHBOARD_MINIVISION_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_MINIVISION_DWELLTIMELINE.failure,
    },
    transform: (state, { payload }) =>
        Object.keys(payload || {}).reduce((carry, date) => {
            return [
                ...carry,
                {
                    moment: date,
                    time: payload[date],
                },
            ]
        }, []),
})

/**
 * Minivision Interaction
 */
const minivisionInteractions = buildAsyncStatReducer({
    key: Metrics.MINIVISION_INTERACTIONS,
    types: {
        request: Types.DASHBOARD_MINIVISION_INTERACTIONS.request,
        success: Types.DASHBOARD_MINIVISION_INTERACTIONS.success,
        failure: Types.DASHBOARD_MINIVISION_INTERACTIONS.failure,
    },
    transform: (state, { payload }) => {
        const { count = 0 } = payload[0] || {}
        return count
    },
})

/**
 * Minivision Interaction (Grouped)
 */
const minivisionInteractionsGrouped = buildAsyncStatReducer({
    key: Metrics.MINIVISION_INTERACTIONS_GROUPED,
    types: {
        request: Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.request,
        success: Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.success,
        failure: Types.DASHBOARD_MINIVISION_INTERACTIONS_GROUPED.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ type: interactionType, count: interactionCount }) => ({
            type: interactionType,
            count: interactionCount,
        }))
    },
})

/**
 * Minivision Soundbars Top
 */
const minivisionSoundbarsTop = buildAsyncStatReducer({
    key: Metrics.MINIVISION_SOUNDBARS_TOP,
    types: {
        request: Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.request,
        success: Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.success,
        failure: Types.DASHBOARD_MINIVISION_SOUNDBARS_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { soundbar, count } = payload[0] || {}
        return { soundbar, count }
    },
})

/**
 * Minivision Stores Top
 */
const minivisionStoresTop = buildAsyncStatReducer({
    key: Metrics.MINIVISION_STORES_TOP,
    types: {
        request: Types.DASHBOARD_MINIVISION_STORES_TOP.request,
        success: Types.DASHBOARD_MINIVISION_STORES_TOP.success,
        failure: Types.DASHBOARD_MINIVISION_STORES_TOP.failure,
    },
    transform: (state, { payload }) => {
        const minivisionStoresTopData = payload.map(({ store_code: storeCode, count }) => ({
            storeCode,
            count,
        }))
        return minivisionStoresTopData
    },
})

const minivisionReducers = [
    minivisionContentTop,
    minivisionDwellTimeline,
    minivisionInteractions,
    minivisionInteractionsGrouped,
    minivisionSoundbarsTop,
    minivisionStoresTop,
]

export default minivisionReducers
